export default "__VITE_ASSET__67c7a798__"